import { APP_VERSION } from "../version";
import { COMPANION_PRODUCT } from "../companion";

export function AboutSheet({
  open,
  note,
  notes,
  onClose,
  onCheck,
}: {
  open: boolean;
  note: string;
  notes: string;
  onClose: () => void;
  onCheck: () => void;
}) {
  if (!open) return null;
  return (
    <div className="efb-scrim" data-testid="about-scrim" onClick={onClose}>
      <section
        className="efb-sheet"
        data-testid="about-sheet"
        role="dialog"
        aria-label="About"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="efb-sheet-handle" aria-hidden />
        <header className="efb-sheet-head">
          <strong>About</strong>
          <button type="button" className="efb-text-btn" onClick={onClose} aria-label="Close about">
            Close
          </button>
        </header>
        <img className="about-logo" src="/icons/icon.svg" width={48} height={48} alt="" />
        <p className="kicker">{COMPANION_PRODUCT}</p>
        <h2>Version {APP_VERSION}</h2>
        <p className="muted">
          The flight screens open the pages stored in this app. Account and board calls go to the Pages proxy. The
          Android shell updates from the public Pages manifest.
        </p>
        <button type="button" className="btn" data-testid="check-updates" onClick={onCheck}>
          Check for updates
        </button>
        {note ? <p className="muted" data-testid="about-check-note">{note}</p> : null}
        {notes ? (
          <>
            <p className="kicker">What's new</p>
            <p className="muted" data-testid="about-manifest-notes">
              {notes}
            </p>
          </>
        ) : null}
      </section>
    </div>
  );
}
